import { create } from "zustand";
// format data for slider value label
export const useDocumentListStore = create((set) => ({
  folderId: 1,
  parentFolderId: 0,
  totalDocumentCount: 0,
  totalFolderCount: 0,
  isUploadModalOpen: false,

  setIsUploadModalOpen: (isOpen) => set({ isUploadModalOpen: isOpen }),

  setLoading: (loading) => set({ isLoading: loading }),

  setFolderId: (newFolderId) => {
    set((state) => ({
      ...state,
      folderId: newFolderId,
    }));
  },

  setParentFolderId: (newParentFolderId) => {
    set((state) => ({
      ...state,
      parentFolderId: newParentFolderId,
    }));
  },

  setTotalDocumentCount: (newDocumentCount) => {
    set((state) => ({
      ...state,
      totalDocumentCount: newDocumentCount,
    }));
  },

  setTotalFolderCount: (newFolderCount) => {
    set((state) => ({
      ...state,
      totalFolderCount: newFolderCount,
    }));
  },
}));
